// extracted by mini-css-extract-plugin
export default {"OTTLogoWithText":"NDSiC","logoImage":"B45xW","skeleton-progress":"LOig9"};